import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {BaseApiTemplateService} from '../../shared/base-api-template-service.model';
import {LabelContainerModel} from '../../../../../../models/aggregates/erp/label';
import {Core2Config} from '../../shared/core2Config';
import {ApiResponseModel, BasicApiResponseModel} from '../../shared/api-response.model';
import {ApiVisa} from '../../shared/api-visa.model';
import {LabelCriteriaModelQuery, LabelQueryCriteriaClass} from '../../../criteria';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ShopeeCreateShippingDocumentService extends BaseApiTemplateService<any> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ECOMSYNC_PREFIX + 'shopee/create-shipping-document';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ECOMSYNC_PREFIX + 'shopee/create-shipping-document';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ECOMSYNC_PREFIX + 'shopee/create-shipping-document';
    this.httpClient = http;
  }

  public createShipDoc(branch_guid: string, order_sn: string, package_number: string, tracking_number: string, shipping_document_type: string, visa: ApiVisa ) {
    let params;
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = `${visa.api_domain_url}${this.endpoint_path}`;
    }

    params = new HttpParams()
      .set("branch_guid", branch_guid)
      .set("order_sn", order_sn)
      .set("package_number", package_number)
      .set("tracking_number", tracking_number)
      .set("shipping_document_type", shipping_document_type)

    const UrlByCriteria = this.apiUrl + '?branch_guid=' + branch_guid + '&order_sn=' + order_sn + '&package_number=' + package_number + '&tracking_number=' + tracking_number + '&shipping_document_type=' + shipping_document_type;
    return this.httpClient.post<BasicApiResponseModel<any>>(UrlByCriteria, this.getHttpHeader(visa));
  }

  public createShipDocPromise(branch_guid: string, order_sn: string, package_number: string, tracking_number: string, shipping_document_type: string, visa: ApiVisa ) {
    let params;
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = `${visa.api_domain_url}${this.endpoint_path}`;
    }

    params = new HttpParams()
      .set("branch_guid", branch_guid)
      .set("order_sn", order_sn)
      .set("package_number", package_number)
      .set("tracking_number", tracking_number)
      .set("shipping_document_type", shipping_document_type)

    const UrlByCriteria = this.apiUrl + '?branch_guid=' + branch_guid + '&order_sn=' + order_sn + '&package_number=' + package_number + '&tracking_number=' + tracking_number + '&shipping_document_type=' + shipping_document_type;
    return this.httpClient.post<BasicApiResponseModel<any>>(UrlByCriteria, this.getHttpHeader(visa)).toPromise();
  }

}
